import './menu-dropdown.scss';

import { forwardRef, ReactNode, Ref, SyntheticEvent, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BiMenuAltLeft } from 'react-icons/bi';

import { useNavbarContext } from '@/resources/hooks/useNavbarContext';
import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';

import { CustomMenu } from '../ActiveCategoriesList';
import BookletsLink from '../BookletsLink';
import CategoryLink from '../CategoryLink';
import LoginLink from './LoginLink';

interface CustomToggleProps {
  children: ReactNode;
  onClick: (e: SyntheticEvent<HTMLElement>) => void;
}

const MenuToggle = forwardRef(
  ({ children, onClick }: CustomToggleProps, ref: Ref<HTMLDivElement>) => (
    <div
      className="d-flex align-items-center cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      ref={ref}
    >
      {children}
    </div>
  ),
);

MenuToggle.displayName = 'MenuToggle';

export function MenuDropDown() {
  const [show, setShow] = useState<boolean>(false);

  const { categories, booklets } = useNavbarContext();
  const { configs, order, setShowIdenfificationModal } = useWebContext();
  const textColor = useTextColor(configs.navbar_footer_color);

  return (
    <Dropdown
      className="menu-dropdown pb-1 mb-0"
      show={show}
      onToggle={(isOpen) => setShow(isOpen)}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <Dropdown.Toggle as={MenuToggle} id="dropdown-menu">
        <BiMenuAltLeft size="25" color={textColor} />
        <span style={{ color: textColor, marginLeft: '5px' }}>
          {configs.navbar_dropdown_label ?? 'Menu'}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} className="dropdown-menu-navbar pt-0">
        {order?.client?.type === 3 && (
          <button
            onClick={() => setShowIdenfificationModal(true)}
            type="button"
            className="dropdown-item dropdown-item-navbar login-item pl-4"
            style={{ backgroundColor: configs.default_color, color: textColor }}
          >
            <LoginLink />
          </button>
        )}

        {configs.has_booklet && booklets.length > 0 && (
          <BookletsLink color={''} className="dropdown-item dropdown-item-navbar login-item pl-4" />
        )}

        {categories?.map((category) => (
          <CategoryLink
            isInDropdown
            color="#333"
            category={category}
            className="dropdown-item dropdown-item-navbar"
            key={`actived-${category.type}-navbar-${category.id}`}
            type={category.type}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
